import { Button, Flex, Row } from "antd";
import useWepapp from "../hook/useWepapp";
import { Footer } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

const { Outlet } = require("react-router-dom")

const ProductComponent = ({
    h1 = "",
    h2 = "",
    product = () => { },
    card = () => { },
    navBar = () => { },
    drawer = () => { },


}) => {
    const { goToMenu = () => { } } = useWepapp()
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    return (
        <Flex vertical style={{ display: "flex", flexDirection: "column", height: "100vh", backgroundColor: "#FCF9F6" }} >
            <Flex vertical style={{ color: "#5E5E5E", padding: isPortrait ? "5vh" : "9vh", rowGap: isPortrait ? "2vh" : "4vh", }}>
                <Flex vertical>
                    <span >{h1}</span>
                    <span >{h2}</span></Flex>

                {/* <Button onClick={() => goToMenu("detail")}>click for productDetail</Button> */}
                {product()}
                {card()}
            </Flex>
            {navBar()}
            {drawer()}
        </Flex>
    )
}
export default ProductComponent;